// #region IMPORT
import urlcat from "urlcat";
import {
  IMaintainerCreateApiRequest,
  IMaintainerCreateApiResponse,
  IMaintainerListApiRequest,
  IMaintainerListApiResponse,
  IMaintainerUpdateApiRequest,
  IMaintainerUpdateApiResponse,
} from "../../../../../model/user/maintainer/maintainer.model";
import { Builder, MD, QD } from "../../../api.baseQuery";
import { IEndpointTags } from "../../../api.endpoint";
// #endregion

// #region INTERFACES
export type MaintainerEndpoint = {
  getMaintainers: QD<IMaintainerListApiRequest, IMaintainerListApiResponse>;
  createMaintainer: MD<
    IMaintainerCreateApiRequest,
    IMaintainerCreateApiResponse
  >;
  updateMaintainer: MD<
    IMaintainerUpdateApiRequest,
    IMaintainerUpdateApiResponse
  >;
};
// #endregion

// #region ENDPOINT
export const maintainerTagTypes: IEndpointTags<MaintainerEndpoint> = {
  getMaintainers: "get-maintainers",
  createMaintainer: "create-maintainer",
  updateMaintainer: "update-maintainer",
};

export const maintainerEndpoint = (builder: Builder): MaintainerEndpoint => ({
  getMaintainers: builder.query({
    query: (param) => urlcat("/maintainers", param),
    providesTags: [maintainerTagTypes.getMaintainers],
  }),
  createMaintainer: builder.mutation({
    query: (body) => ({
      url: `/maintainers`,
      method: "POST",
      body,
    }),
    invalidatesTags: [maintainerTagTypes.getMaintainers],
  }),
  updateMaintainer: builder.mutation({
    query: ({ id, ...body }) => ({
      url: `/maintainers/${id}`,
      method: "PATCH",
      body,
    }),
    invalidatesTags: [maintainerTagTypes.getMaintainers],
  }),
});
// #endregion
